import motorcycleIcon from 'assets/images/motorcycle.svg';
import carIcon from 'assets/images/car.svg';
import mpvIcon from 'assets/images/mpv.svg';
import van17dmIcon from 'assets/images/van_17dm.svg';
import van24dmIcon from 'assets/images/van_24dm.svg';
import lorry10ftIcon from 'assets/images/lorry_10ft.svg';
import lorry14ftIcon from 'assets/images/lorry_14ft.svg';
import lorry24ftIcon from 'assets/images/lorry_24ft.svg';
import lorry40ftIcon from 'assets/images/lorry_40ft.svg';

const VEHICLE_PREFERENCE = {
  motorcycle: 'motorcycle',
  car: 'car',
  mpv: 'mpv',
  van_1_7m: 'van_1.7m',
  van_2_4m: 'van_2.4m',
  lorry_10ft: 'lorry_10ft',
  lorry_14ft: 'lorry_14ft',
  lorry_24ft: 'lorry_24ft',
  lorry_40ft: 'lorry_40ft',
  ltl: 'ltl',
};

interface VehiclePreferenceDescription {
  [key: string]: string;
}

// TODO: remove this and use VEHICLE_PREFERENCE_INFO instead
export const VEHICLE_PREFERENCE_DESCRIPTION: VehiclePreferenceDescription = {
  'motorcycle': 'Motorcycle',
  'car': 'Car',
  'mpv': 'MPV',
  'van_1.7m': '1.7m Van',
  'van_2.4m': '2.4m Van',
  'lorry_10ft': '10ft Truck',
  'lorry_14ft': '14ft Truck',
  'lorry_24ft': '24ft Truck',
  'lorry_40ft': '40ft Truck',
  'ltl': 'ltl',
};

interface VehiclePreferenceInfo {
  [key: string]: {
    description: string;
    capacity: string;
    dimension: string;
    icon: string;
    isShown: boolean;
  };
}

export const VEHICLE_PREFERENCE_INFO: VehiclePreferenceInfo = {
  'motorcycle': {
    description: 'Motorcycle',
    capacity: 'Small parcels | 8kg',
    dimension: '0.4 x 0.3 x 0.3m',
    icon: motorcycleIcon,
    isShown: true,
  },
  'car': {
    description: 'Car',
    capacity: 'Parcels | 20kg',
    dimension: '0.7 x 0.5 x 0.5m',
    icon: carIcon,
    isShown: true,
  },
  'mpv': {
    description: 'MPV',
    capacity: 'Parcels | 50kg',
    dimension: '11 x 0.8 x 0.5m',
    icon: mpvIcon,
    isShown: true,
  },
  'van_1.7m': {
    description: '1.7m Van',
    capacity: 'Cartons | 400kg',
    dimension: '1.6 x 1.2 x 1m',
    icon: van17dmIcon,
    isShown: true,
  },
  'van_2.4m': {
    description: '2.4m Van',
    capacity: 'Cartons | 800kg',
    dimension: '2.3 x 1.2 x 1.2m',
    icon: van24dmIcon,
    isShown: true,
  },
  'lorry_10ft': {
    description: '10ft Truck',
    capacity: '≤ 2 pallets | 1 tonne',
    dimension: '2.9 x 1.4 x 1.7m',
    icon: lorry10ftIcon,
    isShown: true,
  },
  'lorry_14ft': {
    description: '14ft Truck',
    capacity: '≤ 3 pallets | 2 tonnes',
    dimension: '4.2 x 1.7 x 1.9m',
    icon: lorry14ftIcon,
    isShown: true,
  },
  'lorry_24ft': {
    description: '24ft Truck',
    capacity: '≤ 12 pallets | 5 tonnes',
    dimension: '7.5 × 2.3 × 2.3m',
    icon: lorry24ftIcon,
    isShown: true,
  },
  'lorry_40ft': {
    description: '40ft Truck',
    capacity: '≤ 21 pallets | 16 tonnes',
    dimension: '40ft Truck',
    icon: lorry40ftIcon,
    isShown: true,
  },
  'ltl': {
    description: 'ltl',
    capacity: '',
    dimension: '',
    icon: '',
    isShown: false,
  },
};

export const VEHICLE_PREFERENCE_FTL_CAPACITY: Record<string, { capacity: string }> = {
  'lorry_10ft': {
    capacity: '≤ 2 pallets | 1 tonne',
  },
  'lorry_14ft': {
    capacity: '≤ 3 pallets or 7 Liferafts | 2 tonnes',
  },
  'lorry_24ft': {
    capacity: '≤ 12 pallets or 12 Liferafts | 5 tonnes',
  },
  'lorry_40ft': {
    capacity: '≤ 21 pallets | 16 tonnes',
  },
}

export default VEHICLE_PREFERENCE;
